import ReactImageGallery from "react-image-gallery";
import { useNavigate, useParams } from "react-router-dom";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import {
  doEndAution,
  getAuctionById,
} from "../../../../../redux/auction/action";
import {
  Commas,
  getDateFormate,
  getTimeFormat,
} from "../../../../Common/AllDateTimeReleventFormate";
import CustomeDurationLabel from "../../../../Common/CustomeLabel/CustomeDurationLabel";
import AuctionTabsss from "./AuctionTabsss";
import BitAuction from "../../../FindWork/SearchAuction/BitAuction";
import Access from "../../../../CustomComponents/Access/Access";
import ActionStatusLabel from "../../../../Common/Label/ActionStatusLabel";
import HelpSupportModal from "../../../../Common/HelpSupport/HelpSupportModal";
import ProfilePic from "../../../../../assests/imgs/Profileplaceholder.svg";
import { IS_LOGGED_IN_USER } from "../../../../../assests/extention/commonfunction";
import ProfileImageWithFallback from "../../../../../common/ProfileImageWithFallback";
import ReactImageGalleryCompoment from "../../../FindWork/SearchContestParticipate/ContestDetails/ReactImageGalleryCompoment";
import CommonTooltip from "../../../../Common/CommonTooltip";
import { addtowishinActionbyid, addtowishinOTSbyid } from "../../../../../redux/ots/action";
import ConfirmModal from "../../../../Common/ConfirmModal";
import { Modal } from 'reactstrap';
import ModelContractPost from '../../../../Common/ContractandPost/ModelContractPost';

export default function ActionOrderDetails() {
  const laung = localStorage.getItem("laung");
  const path = "Assets/scss/FindWork.module.scss";
  const [lan, setLan] = useState(laung ?? "en");
  const [image, setImage] = useState([]);
  const navigate = useNavigate();
  const [winner, setWinner] = useState([]);
  const [totalbit, setTotalbit] = useState(0);
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("description");
  const [theModal, setTheModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmModal1, setConfirmModal1] = useState(false);
  const [contract, setContact] = useState(false);


  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const { id } = useParams();

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const dispatch = useDispatch();

  const getauctionbyid = useSelector(
    ({ auction: { getauctionbyid } }) => getauctionbyid
  );

  useEffect(() => {
    dispatch(getAuctionById(id));
  }, [id]);

  useEffect(() => {
    if (Array.isArray(getauctionbyid?.winning_bid)) {
      setWinner(getauctionbyid?.winning_bid[0]);
    }
    setTotalbit(getauctionbyid?.bids?.length);
  }, [getauctionbyid]);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    if (getauctionbyid?.files) {
      setImage(getauctionbyid?.files);
    }
  }, [getauctionbyid, getauctionbyid?.files]);

  const images =
    Array.isArray(image) &&
    image?.map((file) => ({
      original: file.file,
      thumbnail: file.file,
    }));

  const EndAuction = (id) => {
    const data = {
      type: "2",
      auction_id: id,
      id: id,
    };
    dispatch(doEndAution(data));
  };

  const chatwithus = (item) => {
    const data = {
      post_id: id,
      user_id: item?.user_id,
    };
    navigate(`/${lan}/account/chats/`, { state: { userdetails: data } });
  };

  const Depositminimumamount = () => {
    // const state = {
    //   id: id,
    //   type_of_post: "deposit",
    //   auction_id: id,
    //   deposit_price: getauctionbyid?.deposit_price,
    //   post_price: getauctionbyid?.deposit_price,
    // };
    // navigate(`/${lan}/account/paymentmethodpage`, {
    //   state: {
    //     orderdetails: { ...state },
    //   },
    // });

    navigate(`/${lan}/auctioncontract/${id}`, {
      state: { approvefrom: "buyerfromlist", type: "auction" },
    });
  };

  const checkaccessss = () => {
    setModal(true);
  };

  const currentDate = new Date();
  const startDate = getauctionbyid?.start_date_time && new Date(`${getauctionbyid?.start_date_time}`);
  const actionlabel = startDate > currentDate;


  const addtowishlist11 = (id) => {
    dispatch(addtowishinActionbyid(id));
  };
  const bidtooltipinfo = `${`1. ${getauctionbyid?.auction_bid_deposit || 0}% of the Minimum Bid will be considered as deposit amount. \n
2. User should pay deposit amount before bidding. \n
3. Deposit amount will be refunded, if user does not win, after auction ends.`}`

  const bidtooltipinfo1 = 'The minimum amount required to place a valid bid. Bids lower than this value will not be accepted'
  return (
    <div className="auction-orders project-details packageddetails">
      {modal ? (
        <Access
          modal={modal}
          setModal={setModal}
          // pathurl={`/${lan}/otscontract/${id}`}
          state={"state"}
          checkpermission={"bid_auction"}
          hitmethod={Depositminimumamount}
          masterID={getauctionbyid && getauctionbyid?.id}
          checkrole={false}
        />
      ) : (
        ""
      )}
      <p className="breadcrumbs">
        <a onClick={() => navigate(`/${laung}/searchauction`)}>BSA &gt; </a>{" "}
        {getauctionbyid?.title}
      </p>
      <div className="auctionimages">
        <div className="row">
          {/* <div className="col-md-6">
            <ReactImageGallery
              className="w-100 big-image"
              showPlayButton={false}
              showFullscreenButton={false}
              items={images}
            />
          </div> */}
          <div className="col-md-6">
            <ReactImageGalleryCompoment images={images} />
          </div>
          <div className="col-md-6 package-right padding-left-right">
            <div style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}>
              <p className="close-auction">
                {getauctionbyid?.status == 2
                  ? "Buy & Sell with Auction (BSA) Ended"
                  : getauctionbyid?.status == 3
                    ? "Buy & Sell with Auction (BSA) Completed"
                    : actionlabel
                      ? "Not Started Buy & Sell with Auction (BSA)"
                      : "Buy & Sell with Auction (BSA) Active"}
              </p>
              <button
                className="btn heart-btn mt-4"
                style={{ background: "transparent", padding: "0" }}
                onClick={() => {
                  if (IS_LOGGED_IN_USER) {
                    addtowishlist11(getauctionbyid?.id);
                  } else {
                    setModal(true);
                  }
                }}
              >
                {getauctionbyid?.wishlist == 1 ? (
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/project/heart-active.svg`}
                    alt=""
                  />
                ) : (
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/project/heart.svg`}
                    alt=""
                  />
                )}
              </button>
            </div>

            <ActionStatusLabel item={getauctionbyid} />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: 'center',
                columnGap: '15px',
              }}
            >
              <h3>{getauctionbyid?.title}</h3>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                {getauctionbyid?.agreement_pdf && <a
                  onClick={() => setContact((state) => !state)}
                  style={{ color: "#ef7710", cursor: "pointer", fontWeight: "600", textDecoration: "underline", marginLeft: "auto" }}
                >
                  View contract
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/square-arrow.svg`}
                    alt=""
                    style={{ marginLeft: "5px" }}
                  />
                </a>}
                <button className="background-button btn dis-margin" onClick={() => {
                  if (IS_LOGGED_IN_USER) { setTheModal(true) }
                  else { setModal(true); }
                }}>
                  Dispute
                </button>
              </div>
            </div>
            <div className="increment">
              <p className=" end-in  mb-3" >
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/contestdetails/arrow-up.svg`}
                  alt=""

                />
                {getauctionbyid?.auction_type == 2 ? "Incremental" : "Sealed"}
                {getauctionbyid?.auction_type == 2 ?
                  <CommonTooltip dontshowtitle={true} info={'Each new bid must be slightly higher than the last one.'} /> :
                  <CommonTooltip dontshowtitle={true} info={'Bids are confidential until the auction ends.'} />}
              </p>
            </div>
            {Array.isArray(getauctionbyid?.winning_bid) &&
              getauctionbyid?.winning_bid[0]?.id && (
                <div className="auction-winner">
                  <p>Buy & Sell with Auction (BSA) winner</p>
                  <div className="auction-left">
                    <ProfileImageWithFallback url={winner?.profile_image} />
                    <div>
                      <h2>
                        {winner?.first_name} {winner?.last_name}
                      </h2>
                      <p>{winner?.email_id}</p>
                      <p>
                        {winner && winner.country_code} -{" "}
                        {winner?.mobile_number}
                      </p>
                    </div>
                  </div>
                </div>
              )}

            <div className="price-duration price-padding price-border">
              <div>
                <CommonTooltip title={"Minimum bid"} info={bidtooltipinfo1} />
                <h2>$ {Commas(getauctionbyid?.min_bid)}</h2>
              </div>
              <div>
                <CommonTooltip title={"Minimum deposit"} info={bidtooltipinfo} />
                <h2>$ {Commas(getauctionbyid?.deposit_price)}</h2>
              </div>
              {winner?.id && (
                <div>
                  <h6>Winning bid</h6>
                  <h2>$ {Commas(winner?.price)}</h2>
                </div>
              )}
            </div>
            <div className="price-duration price-padding">
              <div>
                <h6>Start date and time (in UTC)</h6>
                <h2>
                  {getDateFormate(getauctionbyid?.start_date)},{" "}
                  {getTimeFormat(getauctionbyid?.start_date_time)}
                </h2>
              </div>
            </div>

            <div className="price-duration price-padding">
              <div>
                <h6>Duration</h6>
                <h2>
                  <CustomeDurationLabel
                    duration={getauctionbyid?.duration}
                    duration_type={getauctionbyid?.duration_type}
                  />
                </h2>
              </div>
              <div>
                <h6>Delivery option</h6>
                <h2>{getauctionbyid?.delivery_type_title}</h2>
              </div>
            </div>
            {getauctionbyid?.status == 1 &&
              getauctionbyid?.is_mine != 1 &&
              getauctionbyid?.deposited ? (
              <div>
                <BitAuction
                  getauctionbyid={getauctionbyid}
                  navigate={navigate}
                  setActiveTab={setActiveTab}
                  activeTab={activeTab}
                />
              </div>
            ) : (
              ""
            )}
            {getauctionbyid?.status > 1 &&
              Array.isArray(getauctionbyid?.winning_bid) &&
              getauctionbyid?.winning_bid?.length > 0 && (
                <div className="chat-buyer">
                  <button
                    className="buttons border-button"
                    onClick={() => {
                      getauctionbyid?.is_mine == 1
                        ? chatwithus(winner)
                        : chatwithus(getauctionbyid);
                    }}
                  >
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/common/message-color.svg`}
                      alt=""
                    />{" "}
                    Chat with{" "}
                    {getauctionbyid?.is_mine == "0" ? "Seller" : "Buyer"}
                  </button>
                  {/* <button className="chat-disabled">Get paid</button> */}
                </div>
              )}
            {getauctionbyid?.status == 1 && getauctionbyid?.is_mine == 1 ? (
              <button onClick={() => setConfirmModal(true)} className="buttons ">
                {Array.isArray(getauctionbyid?.bids) &&
                  getauctionbyid?.bids?.length > 0
                  ? "End Buy & Sell with Auction (BSA)"
                  : "Cancel Buy & Sell with Auction (BSA)"}
              </button>
            ) : (
              ""
            )}
            {getauctionbyid?.status == 1 &&
              getauctionbyid?.deposited == null &&
              getauctionbyid?.is_mine != 1 ? (
              <button onClick={() => setConfirmModal1(true)} className="buttons ">
                Pay Deposit to Join Auction
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
        <AuctionTabsss
          winner={winner}
          data={getauctionbyid}
          totalbit={totalbit}
          setActiveTab={setActiveTab}
          activeTab={activeTab}
        />
        <HelpSupportModal
          theModal={theModal}
          setTheModal={setTheModal}
          data={getauctionbyid}
          masterID={id}
          masterType="2"
        />
        <Modal
          size="xl"
          className="popupmodal rent-modal"
          isOpen={contract}
          toggle={() => setContact((state) => !state)}
        >
          <ModelContractPost
            setContact={setContact}
            proposalmilestones={{ agreement_pdf: getauctionbyid?.agreement_pdf }}
          />
        </Modal>
        <ConfirmModal
          isOpen={confirmModal}
          toggle={() => setConfirmModal(false)}
          title=""
          message="Are you sure you want to end this active auction?"
          onConfirm={() => { EndAuction(id); }}
        />
        <ConfirmModal
          isOpen={confirmModal1}
          toggle={() => setConfirmModal1(false)}
          title=""
          message="Do you want to pay deposit to join auction?"
          onConfirm={() => { checkaccessss(); }}
        />
      </div>
    </div>
  );
}
